import React from 'react';
import classNames from "classnames/bind";
import PlagiarizeLinkItem from './PlagiarizeLinkItem';
import Styles from './PlagiarizeLink.scss';

const cx = classNames.bind(Styles);

class PlagiarizeLink extends React.PureComponent {
  constructor(props) {
    super(props);
    const defaultLink = [{ id: this.guid() }];
    this.state = {
      linkList: defaultLink,
    };
    const { onChange } = props;
    onChange(defaultLink);
  }

  guid = () => {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (`${S4() + S4()  }-${  S4()  }-${  S4()  }-${  S4()  }-${  S4()  }${S4()  }${S4()}`);
  }

  checkValue = () => {
    let { linkList } = this.state;
    linkList = linkList.map(item => {
      let error = null;
      if (!item.originValue && item.originValue !== '0') {
        error = '请输入链接';
      }
      if (!item.plagiarizeValue && item.plagiarizeValue !== '0') {
        error = '请输入链接';
      }
      return { ...item, error };
    });
    this.setState({ linkList: [...linkList] })
    return linkList;
  };

  handleAddLinkItem = () => {
    const { linkList } = this.state;
    const addItem = { id: this.guid() };
    this.setState({
      linkList: [...linkList, addItem],
    }, () => {
      const { onChange } = this.props;
      onChange([...linkList, addItem]);
    });
  };

  handleDeleteCurrent = data => {
    const { linkList } = this.state;
    const index = linkList.findIndex(item => item.id === data);
    if (index !== -1) {
      linkList.splice(index , 1);
    }
    this.setState({
      linkList: [...linkList],
    }, () => {
      const { onChange } = this.props;
      onChange(linkList);
    });
  };

  handleChangeValue = data => {
    const { linkList } = this.state;
    const index = linkList.findIndex(item => item.id === data.id);
    if (index !== -1) {
      linkList[index].originValue = data.originValue;
      linkList[index].plagiarizeValue = data.plagiarizeValue;
    }
    this.setState({ linkList: [...linkList] }, () => {
      const { onChange } = this.props;
      onChange(linkList);
    });
  };

  render() {
    const { linkList } = this.state;
    return (
      <div className={cx('plagiarize-link')}>
        <div className={cx('plagiarize-link__label')}>
          <span style={{ color: '#e25050' }}>*</span>
          <span>填写链接</span>
          <span>:</span>
        </div>
        <div className={cx('plagiarize-link__content')}>
          {linkList.map((item, index) => {
            const current = linkList.find(data => data.id === item.id);
            return (
              <PlagiarizeLinkItem hideDel={!index} data={current} onChange={this.handleChangeValue} onDeleteCurrent={this.handleDeleteCurrent} key={item.id} id={item.id} />
            )
          })}
        </div>
        <button className={cx('plagiarize-link__add')} onClick={this.handleAddLinkItem} type="button">+添加更多抄袭内容</button>
      </div>
    );
  }
}

export default PlagiarizeLink;
